$(document).ready(function(){
  $('html,body').animate({ scrollTop: 0 }, '1');
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  $('.title').css('transform','translate(0,'+((windowHeight-titleHeight)/2)+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','800ms');
    $('.title').css('transform','translate(0,0)');
    $('.overlay_white').fadeOut(1000);
    $('.keyboard_container').addClass('active');
  },1400);
  setTimeout(function(){
    $('.chara_switch').addClass('active');
  },1800);
});

$(window).on('load resize',function(){
  var pointHeight = $('.point_img>div').height()*1.3;
  if ($('.sp').css('display') != "none") {
    $('.point_img').css('height',pointHeight+"px");
  }else{
    $('.point_img').css('height',"auto");
  }
});

$(function(){
  // キーボードフキダシ　ホバーアクション
  $('.check_area a,.check,.fukidashi,.check_icon').hover(function(){
    $(this).parent().find('.fukidashi').addClass('active');
    $(this).parent().find('.check_icon').addClass('hover');
  },function(){
    $(this).parent().find('.fukidashi').removeClass('active');
    $(this).parent().find('.check_icon').removeClass('hover');
  });

  // キャラアイコン　ホバーアクション
  $('.chara_switch ul li').hover(function(){
    $(this).find('.circle').addClass('hover');
    $(this).find('.click_icon').addClass('hover');
    $(this).find('.chara_icon').addClass('hover');
  },function(){
    $(this).find('.circle').removeClass('hover');
    $(this).find('.click_icon').removeClass('hover');
    $(this).find('.chara_icon').removeClass('hover');
  });

  // キャラアイコン　クリックアクション
  $('.chara_switch ul li').click(function(){
    var charaName = $(this).data('chara');
    $('.chara_switch ul li .circle').removeClass('bg_madoka bg_homura bg_mami bg_sayaka bg_kyoko bg_kyube');
    $(this).find('.circle').addClass('bg_'+charaName+'');

    // キーボード切り替え
    var switchNum = $(this).index()+1;
    $('.keyboard ul li .kb_window').removeClass('active');
    $('.keyboard ul li:nth-child('+switchNum+') .kb_window').addClass('active');
    $('.keyboard ul li .kb_window').removeClass('ready');
    $('.keyboard ul li:nth-child('+switchNum+') .kb_window').addClass('ready');
    $('.check>div').removeClass();
    $('.check>div').addClass('point_border_'+charaName+'');

    // キーボード　フキダシ、check切り替え
    $('.fukidashi').remove();
    $('.check_icon').remove();
    $('.check_area a').each(function(){
      var fukidashiNum = $(this).parent().data('fukidashi');
      $(this).append('<div class="fukidashi"><img src="https://cdn.shopify.com/s/files/1/0715/8959/3387/files/mdmg_'+charaName+'_fukidashi'+fukidashiNum+'.png" alt=""></div>');
      $(this).append('<div class="check_icon"><img src="https://cdn.shopify.com/s/files/1/0715/8959/3387/files/mdmg_'+charaName+'_check.png" alt=""></div>');
    });

    // キーボード　キュゥべえ用
    $('.check_area').css('display','inline-block');
    if (charaName=="kyube") {
      $('.check_area.area2,.check_area.area1-3').css('display','none');
    }

    // キーボードフキダシ　ホバーアクション
    $('.check_area a,.check,.fukidashi,.check_icon').hover(function(){
      $(this).parent().find('.fukidashi').addClass('active');
      $(this).parent().find('.check_icon').addClass('hover');
    },function(){
      $(this).parent().find('.fukidashi').removeClass('active');
      $(this).parent().find('.check_icon').removeClass('hover');
    });

    // テキスト、ボーダー　カラー切り替え
    $('.change_color').removeClass('color_madoka color_homura color_mami color_sayaka color_kyoko color_kyube');
    $('.change_color').addClass('color_'+charaName);

  });

  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });

  // スクロールアクション
  $(window).scroll(function (){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > 400){
      $('.totop').fadeIn();
    }else{
      $('.totop').fadeOut();
    }
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.35;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('scroll_show');
        }
    });
  });

});
